import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/*
      ChartOverlayProvider deliberately does NOT live here. Mounted above AuthProvider it could
      not see who was signed in and never reset, so overlays and studies created by one account
      were still on the chart when a different account signed in. It now sits inside the
      authenticated area, keyed by user, so every session starts clean. See App.js.
    */}
    <App />
  </React.StrictMode>
);
